export default (that) => [
  {
    field: "seq",
    minWidth: 40,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_operation") || "操作",
    headerAlign: "center",
    align: "center",
    minWidth: 80,
    slots: {
      default: "opt",
    },
  },
  {
    title: that.$l("table_Package_Batch_Type") || "包装采购执行批次类型",
    field: "v_packageBatchType",
    headerAlign: "center",
    align: "center",
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_deliveryDate") || "交货日期",
    field: "deliveryDate",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_deliveryQty") || "交货数量",
    field: "deliveryQty",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDescription')||"交货说明",
    field: "deliveryDescription",
    headerAlign: "center",
    align: "center",
    minWidth: 240,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
